import gql from "@apollo/client";

const REVIEWS_FAST_QUERY = gql`
	query reviewFast(
		$region_url: String
		$street_id: Int
		$house_id: Int
		$provider_id: Int
		$provider_url: String
		$find_operator: Boolean
		$providerJoin: Boolean
		$sort: String
	) {
		reviewsFast(
			region_url: $region_url
			street_id: $street_id
			house_id: $house_id
			provider_id: $provider_id
			provider_url: $provider_url
			find_operator: $find_operator
			providerJoin: $providerJoin
			sort: $sort
		) {
			data {
				id
				title
				date
				rating_type
				review
				time_of_use
				services_of_use
				real
				provider {
					id
					name
					mobile_operator
				}
				author {
					name
				}
				answers {
					list {
						id
						text
						type
						date
						user {
							id
							name
							description
							photo
						}
					}
				}
			}
		}
	}
`;

export default REVIEWS_FAST_QUERY;
